import { ReactComponent as ArrowIcon } from 'assets/images/icons/arrow-icon.svg'
import { ReactComponent as ExternalLinkIcon } from 'assets/images/icons/external-link-icon.svg'
import { ToolIcon } from 'components/Icon'
import { Icon } from 'components/uikit/Icon/Icon'
import { Tag } from 'components/uikit/Tag/Tag'
import { Tooltip } from 'components/uikit/Tooltip/Tooltip'
import { useIntercom } from 'hooks/useIntercom'
import { AnalyticsActionType } from 'types/analytics.type'
import { trackAnalytics } from 'utils/analytics'

import styles from './TableBody.module.scss'
import { TableAppData } from '../../../../types/appData'

interface Props {
  appData: TableAppData[]
}

const TableBody = ({ appData }: Props) => {
  const { showIntercom } = useIntercom()

  const handleAnalyticsClick = (card: TableAppData, isExternal = false) => {
    const kind = isExternal ? 'externallink' : 'internallink'
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: {
        action: `pg_act_toolsandsupport_allworktools_${kind}`,
        params: [
          {
            key: 'name',
            value: card.name ?? '',
          },
          {
            key: 'category',
            value: card.category?.name ?? '',
          },
          {
            key: 'description',
            value: card.description ?? '',
          },
          {
            key: 'media',
            value: card.icon ?? '',
          },
          {
            key: 'action',
            value: card.action ?? '',
          },
        ],
      },
    })
  }

  const handleIntercom = (card: TableAppData) => {
    showIntercom()
    handleAnalyticsClick(card)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleArrowClick = (card: TableAppData, isExternal: boolean = false) => {
    handleAnalyticsClick(card, isExternal)
  }

  return (
    appData && (
      <tbody>
        {appData?.map((app: TableAppData) => (
          <tr key={app.name}>
            <td className={styles.rowFlex}>
              <ToolIcon src={app.icon ?? ''} alt={app.name ?? 'tool'} />
              <span className="font-semibold flex-1 font-Inter">{app.name}</span>
            </td>
            <td className={styles.row}>
              {app?.category?.name && (
                <Tag
                  label={app?.category?.name || ''}
                  className="whitespace-nowrap"
                  bgColor="#abe6ff"
                  textColor="#193abe"
                />
              )}
            </td>
            <td className={styles.row}>
              <Tooltip
                content={`${app.description}`}
                className={styles.tooltip}
                config={{
                  maxWidth: '300px',
                  delay: 0,
                  allowHTML: true,
                }}
              >
                <span className={styles.tableText}>{app.description}</span>
              </Tooltip>
            </td>

            <td className={styles.row}>
              {app?.name?.toLowerCase() === 'intercom' ? (
                <Icon icon={ArrowIcon} className={styles.icon} color="#8b919a" onClick={() => handleIntercom(app)} />
              ) : app?.action === 'external_tool' ? (
                <a href={app.tool} target="_blank" rel="noreferrer">
                  <Icon
                    icon={ExternalLinkIcon}
                    className={styles.icon}
                    color="#8b919a"
                    onClick={() => handleArrowClick(app, true)}
                  />
                </a>
              ) : (
                <a href={app?.tool} target="_blank" rel="noreferrer">
                  <Icon
                    icon={ArrowIcon}
                    className={styles.icon}
                    color="#8b919a"
                    onClick={() => handleArrowClick(app)}
                  />
                </a>
              )}
            </td>
          </tr>
        ))}
        {appData.length === 0 && (
          <tr>
            <td className={styles.noResultsRow}>
              <span className={styles.tableText}>No apps found</span>
            </td>
          </tr>
        )}
      </tbody>
    )
  )
}

export default TableBody
